module.exports = __webpack_public_path__ + "static/header_logo-5a8c4baa379e27e6600a317eee3efaf2.png";